import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import PersonIcon from '@material-ui/icons/Person';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import RolePicker from '../custom/RolePicker'
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';

import { createNewUser, createUseReset } from '../../store/actions/authActions'
import OrganizationPicker from '../custom/OrganizationPicker'
import { checkSA, checkA } from '../../constant'
import Loader from '../../components/custom/loader'
import { firestoreConnect } from 'react-redux-firebase'



const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 1000,
      maxWidth: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing,
  },
  submit: {
    marginTop: theme.spacing(3),
  },
});

class CreateUser extends React.Component {

  state = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    designation: '',
    phoneNumber: '',
    employeeCode: '',
    error: '',
    organization: null
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();

    const { organization, role } = this.state;

    if (!role) {
      this.setState({ error: 'Please select a role' }); return
    }

    const { firestore, userId, history } = this.props;
    
    if (userId) {
      const { firstName, lastName, designation, phoneNumber, employeeCode, role } = this.state;

      console.log({ firstName, lastName, designation, phoneNumber, employeeCode, role })

      firestore.update(
        { collection: 'users', doc: userId },
        { firstName, lastName, designation, phoneNumber, employeeCode, role, displayName: firstName + ' ' + lastName },
      )
        .then((data) => {
           history.push('/users')
          }, (err) => {
            alert(err.message)
           },
        );

      return
    }

    if (!organization) {
      this.setState({ error: 'Please select a organization' }); return
    }

    this.setState({ error: '' });

    const data = this.state;
    delete data.error;
    this.props.createNewUser(data);
  }

  selectOrganization = (organization) => {
    this.setState({ organization })
  }

  selectRole = (role) => {
    this.setState({ role })
  }

  // componentWillReceiveProps(nextProps) {
  //   const { userDetails, userId } = nextProps;
  //   console.log('  componentWillReceiveProps: ', userId, this.props.userDetails)

  //   if (userDetails) {
  //     const { firstName, lastName, designation, phoneNumber, employeeCode } = userDetails;
  //     console.log(firstName, lastName, designation, phoneNumber, employeeCode)
  //     this.setState({ firstName, lastName, designation, phoneNumber, employeeCode });
  //   }
  // }

  render() {
    const { classes, auth, user, createUseReset, history, profile, userDetails, userId } = this.props;
    const { firstName, lastName, designation, phoneNumber, employeeCode, role } = this.state;

    if (userDetails && ! firstName) {
      const { firstName, lastName, designation, phoneNumber, employeeCode, role } = userDetails;
      this.setState({ firstName, lastName, designation, phoneNumber, employeeCode, role });
    }

    const colWidth = {
      xs: 12, sm: 6
    }

    console.log("profile : ", profile)

    if (!auth.uid) return <Redirect to='/signin' />

    if (!profile) return <Loader />

    if (!user.error && user.userDetails) {
      history.push('/users');
      createUseReset();
      return null;
    }

    if (profile && checkA(profile) && !this.state.organization) {
      this.setState({ organization: profile.organization })
    }


    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <PersonIcon />
            </Avatar>
            <Typography variant="h4">Create User</Typography>
            <form className={classes.form} onSubmit={this.handleSubmit} >

              <Grid container spacing={3}>

                {
                  !userId
                  &&
                  <React.Fragment>
                    <Grid item {...colWidth}>
                      <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="email">Email Address</InputLabel>
                        <Input
                          onChange={this.handleChange}
                          id="email" name="email" autoComplete="email" autoFocus />
                      </FormControl>
                    </Grid>

                    <Grid item {...colWidth}>
                      <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input
                          onChange={this.handleChange}
                          name="password"
                          type="password"
                          id="password"
                          autoComplete="current-password"
                        />
                      </FormControl>
                    </Grid>
                  </React.Fragment>
                }

                <Grid item {...colWidth}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="firstName">First Name</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      name="firstName"
                      type="text"
                      id="firstName"
                      value={firstName}
                    />
                  </FormControl>
                </Grid>

                <Grid item {...colWidth}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="lastName">Last Name</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      name="lastName"
                      type="text"
                      id="lastName"
                      value={lastName}
                    />
                  </FormControl>
                </Grid>

                {
                  profile && !checkSA(profile) ?
                    <Grid item {...colWidth}>
                      <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="employeeCode">Employee Code</InputLabel>
                        <Input
                          onChange={this.handleChange}
                          name="employeeCode"
                          type="text"
                          id="employeeCode"
                          value={employeeCode}
                        />
                      </FormControl>
                    </Grid>
                    : null
                }
                <Grid item {...colWidth}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="designation">Designation</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      name="designation"
                      type="text"
                      id="designation"
                      value={designation}
                    />
                  </FormControl>
                </Grid>


                <Grid item {...colWidth}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="phoneNumber">Mobile Number</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      name="phoneNumber"
                      type="text"
                      id="phoneNumber"
                      value={phoneNumber}
                    />
                  </FormControl>
                </Grid>
                {
                  profile && checkSA(profile) ?
                    <Grid item {...colWidth}>
                      <FormControl margin="normal" required fullWidth>
                        <OrganizationPicker onChange={this.selectOrganization} label="Select Organization" />
                      </FormControl>
                    </Grid>
                    : null
                }
                <Grid item {...colWidth}>
                  <FormControl margin="normal" required fullWidth>
                    <RolePicker value={role ? { roleTitle: role } : null} onChange={this.selectRole} label="Select Role" />
                  </FormControl>
                </Grid>

                {user.error && user.error.message ? <div>  <br /> <Typography component="p" color="error" align="center"> {user.error.message}</Typography> <br /> </div> : null}
                {this.state.error ? <div>  <br /> <Typography component="p" color="error" align="center"> {this.state.error}</Typography> <br /> </div> : null}
              </Grid>

              <div style={{ textAlign: 'center' }}>

                {
                  user.loading ?
                    <Loader />
                    :
                    <Button
                      type="submit"
                      style={{ margin: '10px auto' }}
                      variant="contained"
                      color="primary"
                      startIcon={!userId && <AddIcon />}
                    > {userId ? 'Update' :  'Add New'} User </Button>
                }

              </div>

            </form>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}
CreateUser.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const userId = ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.userId
  const users = state.firestore.data.users;

  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    user: state.userReducer,
    userId,
    userDetails: users && (userId && (users[userId] || {})),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createNewUser: (newUser) => dispatch(createNewUser(newUser)),
    createUseReset: () => dispatch(createUseReset())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (props.userId) {
      return [
        {
          collection: 'users',
          doc: props.userId,
        }
      ]
    } else {
      return [];
    }
  })
)(withStyles(styles)(CreateUser));